<template>
  <div>
    <breadcrumbs :two="{ path: '/tuning', name: this.page_title }"></breadcrumbs>
    <div class="main">
      <h3>{{ page_title }}</h3>
      <div class="main-content">
        <loading v-if="loading"></loading>
        <div v-if="!loading">
          <el-row>
            <el-col :span="24">
              <div class="el-card box-card is-always-shadow">
                <div class="el-card__header">
                  <div class="clearfix">
                    <span>Фильтры</span>
                  </div>
                </div>
                <div class="el-card__body">
                  <el-row :gutter="24">
                    <el-col class="mb-2" :span="6" :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                      <span class="demo-input-label">Бренд: </span><br/>
                      <el-select v-model="filterBrandID" filterable
                                 placeholder="Начните вводить/выберите">
                        <el-option
                            v-for="item in brands_list"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                  <el-row :gutter="24">
                    <el-col>
                      <el-button type="success" round @click="getData" icon="el-icon-check"
                                 title="Фильтр"></el-button>
                      <el-button type="danger" round @click="resetFilters" icon="el-icon-close"
                                 title="Очистить"></el-button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-table :data="items" border stripe style="width: 100%" @sort-change="filterChange">
            <template>
              <el-table-column label="Бренд" prop="brand_name"></el-table-column>
              <el-table-column label="Название" prop="name">
                <template slot-scope="scope">
                  <a :href="'/tuning/item/' + scope.row.tuning_id">{{ scope.row.name }}</a>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <el-pagination
              v-if="!loading"
              class="pagination"
              background
              layout="pager"
              :total="totalElements"
              :page-size="numberOfElements"
              :current-page.sync="page"
              @current-change="setCurrentPage"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import {axios} from "@/api";
import Loading from "@/components/Loading";

export default {
  name: 'Tuning',
  data() {
    return {
      loading: true,
      activeIndex: '/tuning',
      controller: 'user/tuning/list/png',
      controllerDelete: 'user/tuning/delete',
      controllerBrandsList: 'json/data/31/UBrands/UBrandsList2.json',
      page_title: 'Тюнинг',
      items: [],
      search: '&sort=updated_at%2Cdesc',
      totalElements: 2,
      number: 0,
      page: 1,
      numberOfElements: 30,
      brands_list: [],
      filterBrandID: '',
      selectID: 0,
      selectIndex: 0
    };
  },
  components: {
    Breadcrumbs,
    Loading
  },
  methods: {
    async getData() {
      let fBrandID = ''
      if (this.filterBrandID > 0) {
        fBrandID = `&brand_id=${this.filterBrandID}`
      }

      try {
        this.loading = true;
        await axios.get(`${process.env.VUE_APP_API_V1}/${this.controller}/?page=${this.number}&size=${this.numberOfElements}${fBrandID}${this.search}`)
            .then((response) => {
              console.log(JSON.stringify(response.data));
              this.items = response.data.items.elements;
              this.totalElements = response.data.items.totalElements;
            })
            .catch((error) => {
              console.log(error);
            });

        await axios.get(`${process.env.VUE_APP_API}/${this.controllerBrandsList}`)
            .then((response) => {
              this.brands_list = response.data.items.map(item => {
                return { id: `${item.id}`, name: `${item.name}` };
              });
            })
            .catch((error) => {
              console.log(error);
            });
        this.loading = false;
      } catch (e) {
        if (e.response && e.response.status === 403) {
          this.loading = true;
          this.$notify.error({
            title: '403 - Доступ запрещён!',
            message: 'У Вас нет прав для доступа к странице'
          });
        }
      }
    },
    filterChange(row) {
      if (row.order === 'ascending') {
        this.search = `&sort=${row.prop}%2Cdesc`
      } else if (row.order === 'descending') {
        this.search = `&sort=${row.prop}%2Casc`
      } else {
        this.search = ''
      }
    },
    resetFilters() {
      this.filterBrandID = '';
      this.getData()
    },
    async setCurrentPage() {
      this.number = (this.page - 1)
      await this.getData()
    },
  },
  async mounted() {
    await this.getData()
  },
  watch: {
    async search() {
      await this.getData()
    },
    async numberOfElements() {
      await this.getData()
    },
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
